export default import.meta.ROLLUP_FILE_URL_EyDcjPAvLJN_343RPLPX5A